document.addEventListener('DOMContentLoaded', () => {
    const input = document.querySelector('#exact-word');

    if (!input) return;

    const lawSelect = document.querySelector('#law-select');
    const exactSearch = document.querySelector('#exact-expr');
    const excludeFromSearch = document.querySelector('#exclude-word');
    const resultsPanel = document.querySelector('#ajax-results');
    const searchForm = document.querySelector('#search-topoclp');
    const submitButton = document.querySelector('.btn-search-submit');

    let debounceTimeout = null;

    const closeResults = () => {
        resultsPanel.style.display = 'none';
    };

    const openResults = () => {
        if (resultsPanel.innerHTML.trim().length) {
            resultsPanel.style.display = '';
        }
    };

    [input, lawSelect, exactSearch, excludeFromSearch].forEach((field) => {
        field?.addEventListener('input', () => {
            const query = input.value.trim();
            if (query) {
                const params = {
                    lois: lawSelect.value,
                    exact: exactSearch.checked,
                    exclude: excludeFromSearch.value,
                };

                clearTimeout(debounceTimeout);

                debounceTimeout = setTimeout(() => {
                    let url = `${searchForm.dataset.suggest}&tx_solr[q]=${encodeURIComponent(query)}`;

                    Object.entries(params).forEach(([param, value]) => {
                        if (value) {
                            url += `&tx_solr[${param}]=${value}`;
                        }
                    });

                    fetch(url)
                        .then((response) => response.text())
                        .then((data) => {
                            resultsPanel.innerHTML = '';
                            if (data.length) {
                                resultsPanel.innerHTML = data;
                                openResults();
                                const modalButton = document.querySelector('#modal-submit');
                                modalButton?.addEventListener('click', () => submitButton.click());
                            } else {
                                closeResults();
                            }
                        });
                }, 300);
            } else {
                resultsPanel.innerHTML = '';
                closeResults();
            }
        });
    });
    // Close when clicking outside
    document.addEventListener('click', (e) => {
        if (
            resultsPanel.innerHTML.trim().length
            && !resultsPanel.contains(e.target)
            && !searchForm.contains(e.target)
        ) {
            closeResults();
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeResults();
            if (document.activeElement === input) {
                input.blur();
            }
        }
    });
    // Open on input focus
    input.addEventListener('focus', () => {
        openResults();
    });
});
